import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ApplicationService } from 'services/application.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-valogin',
  templateUrl: './valogin.component.html',
  styleUrls: ['./valogin.component.scss']
})
export class ValoginComponent implements OnInit {
  form: FormGroup;
  data: any;
  applicationid: any;
  networkIdentifier: any;
  showpassword: boolean = false;
  wifiCredential: any;
  refNo: any;

  constructor(private applicationservice: ApplicationService, private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<ValoginComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToAdd: any,
    private toastr: ToastrService) { }

  ngOnInit() {
    this.initializeValidators();
    this.pageload();
  }
  initializeValidators() {
    this.form = this.formBuilder.group({
      username: [''],
      password: [''],
      cpassword: ['', [Validators.required, Validators.maxLength(32), Validators.minLength(8)]]
    });
  }
  onCancel() {
    this.dialogRef.close();
  }
  pageload() {
    debugger
    this.applicationid = null;
    this.applicationid = this.dataRecievedToAdd.appId;
    this.networkIdentifier = null;
    this.networkIdentifier = this.dataRecievedToAdd.networkIdentifier;
    this.refNo = null;
    this.refNo = this.dataRecievedToAdd.referncenumber;

    if (this.applicationid != null && this.networkIdentifier == null && this.dataRecievedToAdd.serviceId == null) {
      this.applicationservice.goToPageload(this.applicationid).subscribe(result => {
        this.form.patchValue(result);
        // this.form.controls['Username'].setValue(result.username);
        // this.form.controls['Password'].setValue(result.password);

      })
    }
    if (this.applicationid == null && this.networkIdentifier != null && this.dataRecievedToAdd.serviceId == null) {
      this.applicationservice.getWifiDetails(this.networkIdentifier).subscribe(res => {
        if (res.result != null) {
          this.data = res;
          this.form.controls['username'].setValue(this.data.result.wifi_username);
          this.form.controls['password'].setValue(this.data.result.wifi_password);
        }
        else {
          Swal.fire({
            title: "Oops!",
            text: "We are unable to process your request",
            width: '500px',
            icon: 'warning',
            showCancelButton: false
          }).then((res) => {

            this.dialogRef.close();

          });
        }
      })
    }
    else if (this.dataRecievedToAdd.serviceId != null) {
      this.applicationservice.ZoomWifiDetails(this.dataRecievedToAdd.serviceId).subscribe(res => {
        if (res.result != null) {
          this.data = res;
          this.form.controls['username'].setValue(this.data.result.wifi_username);
          this.form.controls['password'].setValue(this.data.result.wifi_password);
        }
        else {
          Swal.fire({
            title: "Oops!",
            text: "We are unable to process your request",
            width: '500px',
            icon: 'warning',
            showCancelButton: false
          }).then((res) => {

            this.dialogRef.close();

          });
        }
      })
    }
  }

  onUpdate() {
    this.showpassword = true;
  }
  onSubmit() {

    // if(this.form.value.newpassword && this.form.value.application.value)
    if (this.form.valid) {
      var postData = {
        referenceNumber: this.refNo,
        newPassword: this.form.value.cpassword
      };

      this.applicationservice.updateWifiCredentialWithReference(postData).subscribe(response => {
        if (response && response.result && response.result.wifi_username && response.result.wifi_password) {
          this.wifiCredential = response;
          // this.showCredential = false;
          // this.showNewPassword = false;
          Swal.fire({
            title: 'Updated successfully',
            // text: "Username: "+ response.result.wifi_username +". "+"Password: "+ response.result.wifi_password +".",            
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Ok',
          }).then((res) => {
            if (res.value) {
              this.ngOnInit();
            }
          });
          // this.alertService.success('Updated successfully!');
          // this.ngOnInit();
        }
        else {
          // this.showCredential = true;
          Swal.fire({
            title: 'Oops! Something went wrong',
            text: "Unable to Update. Please Try again later!",
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Ok',
          }).then((res) => {
            if (res.value) {
            }
          });
          //this.alertService.warning('Unable to Update. Please Try again later!');
        }
      });
    }
    else {
      this.validateFormControl();
      // this.toastr.error("Please enter Wifi password");      // this.validateFormControl();
    }
  }
  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }

}


